// extracted by mini-css-extract-plugin
module.exports = {"MapCoords":"MapCoords_MapCoords__3B71E","center":"MapCoords_center__GB1zi"};